import styled from 'styled-components';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { Modal, ModalContent } from './Modal';

const TakeoverModal = styled(Modal)`
    ${ModalContent} {
        height: 100%;
        top: 0;
        width: 100%;

        ${breakpoint('xsmall', { down: true })} {
            max-height: none;
        }

        ${breakpoint.small} {
            min-width: 500px;
            padding: 44px 32px 56px;
            width: 500px;
            height: auto;
        }
    }
`;

export { TakeoverModal as default, TakeoverModal };
